import { Flex, NumberField, Text } from '@approvalmax/ui/src/components';
import { memo, useId } from 'react';

import { useFilterNumberRange } from './FilterNumberRange.hooks';
import { messages } from './FilterNumberRange.messages';
import { FilterNumberRangeProps } from './FilterNumberRange.types';

export const FilterNumberRange = memo<FilterNumberRangeProps>((props) => {
    const { filter, onFilterChange } = props;

    const { handleChangeGreaterOrEqual, handleBlurGreaterOrEqual, handleChangeLessOrEqual, handleBlurLessOrEqual } =
        useFilterNumberRange(filter, onFilterChange);
    const id = useId();
    const aboveId = `${id}-above`;
    const belowId = `${id}-below`;

    return (
        <Flex spacing='4' alignItems='baseline' shrink={0} grow={1} wrap={false} data-qa='filter-number-range'>
            <Text as='label' font='label' fontSize='small' color='midnight70' htmlFor={aboveId}>
                {messages.above}
            </Text>

            <Flex width={104}>
                <NumberField
                    id={aboveId}
                    size='small'
                    clearable={false}
                    allowFloat
                    precision={2}
                    data-qa='above-input'
                    placeholder={messages.enter}
                    value={filter.greaterOrEqual}
                    onChange={handleChangeGreaterOrEqual}
                    onBlur={handleBlurGreaterOrEqual}
                />
            </Flex>

            <Text as='label' font='label' fontSize='small' color='midnight70' htmlFor={belowId}>
                {messages.below}
            </Text>

            <Flex width={104}>
                <NumberField
                    id={belowId}
                    size='small'
                    clearable={false}
                    allowFloat
                    precision={2}
                    data-qa='below-input'
                    placeholder={messages.enter}
                    value={filter.lessOrEqual}
                    onChange={handleChangeLessOrEqual}
                    onBlur={handleBlurLessOrEqual}
                />
            </Flex>
        </Flex>
    );
});
